import NestedForm from "@stimulus-components/rails-nested-form"

export default class extends NestedForm {
  static targets = ["picker", "target", "template", "emptyState"]

  connect() {
    super.connect()
    this.syncRowsWithPicker()
  }

  syncFromPicker() {
    this.syncRowsWithPicker()
  }

  remove(event) {
    super.remove(event)
    this.syncPickerFromRows()
    this.toggleEmptyState()
  }

  syncRowsWithPicker() {
    const selectedIds = this.selectedServiceIds()

    selectedIds.forEach((serviceId) => {
      if (!this.rowExists(serviceId)) this.addRowForService(serviceId)
    })

    this.rows().forEach((row) => {
      const serviceId = row.dataset.serviceId
      if (!selectedIds.includes(serviceId)) this.removeRowBySelection(row)
    })

    this.toggleEmptyState()
  }

  addRowForService(serviceId) {
    const option = this.pickerTarget.querySelector(`option[value="${serviceId}"]`)
    if (!option) return

    const templateContent = this.templateTarget.innerHTML
      .replace(/NEW_RECORD/g, this.nextRowIndex())
      .replace(/SERVICE_ID/g, serviceId)
      .replace(/SERVICE_LABEL/g, option.dataset.label || option.textContent.trim())
      .replace(/SERVICE_PRICE/g, option.dataset.price || "0")

    this.targetTarget.insertAdjacentHTML("beforeend", templateContent)
  }

  removeRowBySelection(row) {
    const isNewRecord = row.dataset.newRecord === "true"
    if (isNewRecord) {
      row.remove()
      return
    }

    const destroyInput = row.querySelector("input[name*='[_destroy]']")
    if (destroyInput) destroyInput.value = "1"
    row.style.display = "none"
  }

  syncPickerFromRows() {
    const visibleIds = this.rows()
      .filter((row) => row.style.display !== "none")
      .map((row) => row.dataset.serviceId)

    if (this.pickerTarget.tomselect) {
      this.pickerTarget.tomselect.clear(true)
      visibleIds.forEach((id) => this.pickerTarget.tomselect.addItem(id, true))
      return
    }

    Array.from(this.pickerTarget.options).forEach((option) => {
      option.selected = visibleIds.includes(option.value)
    })
  }

  selectedServiceIds() {
    if (this.pickerTarget.tomselect) return this.pickerTarget.tomselect.items
    return Array.from(this.pickerTarget.selectedOptions).map((option) => option.value)
  }

  rows() {
    return Array.from(this.targetTarget.querySelectorAll(this.wrapperSelectorValue))
  }

  rowExists(serviceId) {
    return this.rows().some((row) => row.dataset.serviceId === serviceId && row.style.display !== "none")
  }

  nextRowIndex() {
    return `${Date.now()}${Math.floor(Math.random() * 10000)}`
  }

  toggleEmptyState() {
    const hasVisibleRows = this.rows().some((row) => row.style.display !== "none")
    this.emptyStateTarget.classList.toggle("hidden", hasVisibleRows)
  }
}
